<template>
    <div class="intro-body">
        <DxDataGrid :data-source="zileRows" ref="gridRef" key-expr="Id" :show-borders="true" height="100%"
            :show-row-lines="true" :row-alternation-enabled="true" @row-updating="onRowUpdating"
            @context-menu-preparing="onContextMenu" no-data-text="Selectează un angajat / încarcă luna.">
            <DxScrolling mode="virtual" />
            <DxSorting mode="none" />
            <DxEditing :allow-updating="!blocata" mode="cell" :select-text-on-edit-start="true" start-edit-action="click" />

            <DxColumn data-field="zi" caption="Zi" :width="45" :allow-editing="false" alignment="center" css-class="col-zi" />
            <DxColumn data-field="ziSapt" caption="Ziua" :width="70" :allow-editing="false" />
            <DxColumn data-field="Val" caption="Ore / Cod" :width="90" data-type="number" alignment="center"
                :customize-text="valText" />
            <DxColumn data-field="ValSup5" caption="Sup 5%" :width="65" data-type="number" alignment="center" />
            <DxColumn data-field="ValSup50" caption="Sup 50%" :width="70" data-type="number" alignment="center" />
            <DxColumn data-field="ValSup75" caption="Sup 75%" :width="70" data-type="number" alignment="center" />
            <DxColumn data-field="ValSup100" caption="Sup 100%" :width="75" data-type="number" alignment="center" />
            <DxColumn data-field="ValSup175" caption="Sup 175%" :width="75" data-type="number" alignment="center" />
            <DxColumn data-field="ValSup200" caption="Sup 200%" :width="75" data-type="number" alignment="center" />
            <DxColumn data-field="ValSupNoapte" caption="Noapte" :width="70" data-type="number" alignment="center" />
            <DxColumn data-field="OraInceput" caption="Oră înc." :width="80" data-type="datetime" format="HH:mm" />
            <DxColumn data-field="OraSfarsit" caption="Oră sf." :width="80" data-type="datetime" format="HH:mm" />
            <DxColumn data-field="Recuperare" caption="Rec." :width="55" data-type="boolean" />
            <DxColumn data-field="Explicatii" caption="Explicații" />
        </DxDataGrid>

        <DxPopup :visible="dayPopupVisible" :show-title="true" :title="dayTitle" :width="620" :height="520"
            :close-on-outside-click="true" @hidden="dayPopupVisible = false">
            <DxForm :col-count="2" :form-data="dayForm" label-alignment="left">
                <DxGroupItem :col-span="2" caption="Prezență">
                    <DxSimpleItem data-field="Val" :label="{ text: 'Ore lucrate / Cod' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="Recuperare" :label="{ text: 'Recuperare' }" editor-type="dxCheckBox" />
                    <DxSimpleItem data-field="OraInceput" :label="{ text: 'Oră început' }" editor-type="dxDateBox"
                        :editor-options="{ type: 'time', displayFormat: 'HH:mm' }" />
                    <DxSimpleItem data-field="OraSfarsit" :label="{ text: 'Oră sfârșit' }" editor-type="dxDateBox"
                        :editor-options="{ type: 'time', displayFormat: 'HH:mm' }" />
                </DxGroupItem>
                <DxGroupItem :col-span="2" :col-count="4" caption="Ore suplimentare">
                    <DxSimpleItem data-field="ValSup5" :label="{ text: '+5%' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="ValSup50" :label="{ text: '+50%' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="ValSup75" :label="{ text: '+75%' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="ValSup100" :label="{ text: '+100%' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="ValSup175" :label="{ text: '+175%' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="ValSup200" :label="{ text: '+200%' }" editor-type="dxNumberBox" />
                    <DxSimpleItem data-field="ValSupNoapte" :label="{ text: 'Noapte' }" editor-type="dxNumberBox" />
                </DxGroupItem>
                <DxSimpleItem data-field="Explicatii" :label="{ text: 'Explicații' }" :col-span="2" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="saveDayBtn" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeDayBtn" />
        </DxPopup>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import {
    DxDataGrid, DxColumn, DxScrolling, DxSorting, DxEditing
} from 'devextreme-vue/data-grid';
import { DxForm, DxSimpleItem, DxGroupItem } from 'devextreme-vue/form';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import notify from 'devextreme/ui/notify';
import RU_Pontaj from '@/services/RU/RU_Pontaj';

export default defineComponent({
    components: {
        DxDataGrid, DxColumn, DxScrolling, DxSorting, DxEditing,
        DxForm, DxSimpleItem, DxGroupItem, DxPopup, DxToolbarItem
    },
    props: {
        zileRows: { type: Array as () => any[], default: () => [] },
        blocata: { type: Boolean, default: false },
        coduriMap: { type: Object as () => Record<number, string>, default: () => ({}) },
        empLabel: { type: String, default: '' },
    },
    data() {
        return {
            gridRef: ref(null),
            valText: null as any,
            dayPopupVisible: false,
            dayForm: {} as any,
            dayTitle: '',
            saveDayBtn: { type: 'success', text: 'Salvează', stylingMode: 'contained', onClick: () => this.saveDay() },
            closeDayBtn: { type: 'danger', text: 'Închide', stylingMode: 'contained', onClick: () => this.closeDay() },
        };
    },
    created() {
        this.valText = (cellInfo: any) => {
            const v = cellInfo?.value;
            if (v === null || v === undefined || v === '') return '';
            return this.coduriMap[v] ?? String(v);
        };
    },
    methods: {
        closeDay() { this.dayPopupVisible = false; },
        onRowUpdating(e: any) {
            const id = e.oldData.Id;
            const payload: any = {};
            for (const k of Object.keys(e.newData)) {
                if (['Val', 'ValSup5', 'ValSup50', 'ValSup75', 'ValSup100', 'ValSup175', 'ValSup200', 'ValSupNoapte', 'OraInceput', 'OraSfarsit', 'Recuperare', 'Explicatii'].includes(k))
                    payload[k] = e.newData[k];
            }
            if (!Object.keys(payload).length) return;
            e.cancel = RU_Pontaj.updateCell(id, payload)
                .then(() => { notify('Salvat.', 'success', 1200); return false; })
                .catch((err: any) => { console.error(err); notify('Eroare la salvare!', 'error', 3000); return true; });
        },
        onContextMenu(e: any) {
            if (e.target !== 'content' || e.row?.rowType !== 'data') return;
            e.items = e.items || [];
            e.items.push({ text: `Detalii / ore suplimentare (ziua ${e.row.data.zi})`, onItemClick: () => this.openDay(e.row.data) });
        },
        openDay(p: any) {
            this.dayTitle = `${this.empLabel} — ziua ${p.zi}`;
            this.dayForm = { ...p };
            this.dayPopupVisible = true;
        },
        async saveDay() {
            const f = this.dayForm;
            const payload = {
                Val: f.Val, Recuperare: f.Recuperare, OraInceput: f.OraInceput, OraSfarsit: f.OraSfarsit,
                ValSup5: f.ValSup5, ValSup50: f.ValSup50, ValSup75: f.ValSup75, ValSup100: f.ValSup100,
                ValSup175: f.ValSup175, ValSup200: f.ValSup200, ValSupNoapte: f.ValSupNoapte, Explicatii: f.Explicatii,
            };
            try {
                await RU_Pontaj.updateCell(f.Id, payload);
                notify('Salvat.', 'success', 1500);
                this.dayPopupVisible = false;
                this.$emit('refresh');
            } catch (e) { console.error(e); notify('Eroare la salvare!', 'error', 3000); }
        },
    },
});
</script>
<style scoped>
.intro-body { height: 100%; }
:deep(.col-zi) { font-weight: 700; background: #f8f9fc; }
</style>
